import { Category } from 'shared/types';
import {
  FacialHairNoColorList,
  MouthWithColorList,
  NoColorAccessoriesList,
  NoColorHairFrontList,
} from 'shared/types/optionSets';
import { OptionState } from '../types';

const noColorCategories = [
  Category.EYES,
  Category.NOSE,
  Category.EARS,
  Category.LOGO
];

/* Layout related constants */
export const STANDARD_HEADER_HEIGHT = 76;
export const STANDARD_MAIN_WINDOW_HEIGHT = 500;
export const STANDARD_AVATAR_VIEW_SIDE = 420;
export const STANDARD_UI_WINDOW_WIDTH = 430;
export const STANDARD_SUPPORT_UI_WINDOW_HEIGHT = 83;
export const STANDARD_BORDER_WIDTH = 4;
export const STANDARD_MAIN_UI_SQUARE_SIDE = 100;
export const STANDARD_MAIN_UI_SQUARE_MARGIN = 28;
export const STANDARD_SUPPORT_UI_SQUARE_SIDE = 35;

/* Used to set main picker window size (needed for scrolling)
 * and show/hide color picker */
export const canSelectColor = (
  category: Category,
  optionState?: OptionState,
) => {
  if (noColorCategories.includes(category)) {
    return false;
  }

  if (optionState) {
    if (
      category === Category.HAIR &&
      NoColorHairFrontList.includes(optionState.hair)
    ) {
      return false;
    }

    if (
      category === Category.FACIAL_HAIR &&
      FacialHairNoColorList.includes(optionState.facialHair)
    ) {
      return false;
    }

    if (
      (category === Category.ACCESSORIES_EYEWEAR &&
        NoColorAccessoriesList.includes(optionState.accessories.eyewear)) ||
      (category === Category.ACCESSORIES_HEADGEAR &&
        NoColorAccessoriesList.includes(optionState.accessories.headgear)) ||
      (category === Category.ACCESSORIES_FANFETTI &&
        NoColorAccessoriesList.includes(optionState.accessories.fanfetti))
    ) {
      return false;
    }

    if (category === Category.MOUTH) {
      if (!MouthWithColorList.includes(optionState.mouth)) {
        return false;
      }
    }
  }

  return true;
};

/* Modal sizes */
export const MODAL_HEIGHT = 156;
export const MODAL_WIDTH = 420;
export const MODAL_BUTTON_HEIGHT = 50;
export const MODAL_BUTTON_WIDTH = 100;

/* Layer piece styling */
export const STANDARD_LAYER_VIEWBOX = '0 0 1000 1000';

export const getAvatarViewLayerStyle = (zIndex: number) => {
  return { zIndex, position: 'absolute', width: '100%', height: 'auto' };
};

export const DEFAULT_THUMBNAIL_STYLE = {
  zIndex: 0,
  position: 'relative',
  width: '100%',
  height: 'auto',
};

// Used when displaying options with multiple layers
export const getDefaultThumbnailViewStyle = (zIndex: number) => {
  return { zIndex, position: 'relative', width: '100%', height: 'auto' };
};
export const getLayeredHairThumbnailViewStyle = (zIndex: number) => {
  return {
    zIndex,
    position: 'absolute',
    width: '100%',
    height: 'auto',
    left: 0,
    top: -45,
  };
};

export const HAIR_THUMBNAIL_VIEWBOX = '75 75 850 850';

/* Avatar view layer z-index */
export const BACKGROUND_Z_INDEX = 0;
export const HAIR_BACK_Z_INDEX = 10;
export const HEAD_Z_INDEX = 20;
export const EYES_Z_INDEX = 30;
export const NOSE_Z_INDEX = 40;
export const MOUTH_Z_INDEX = 50;
export const HAIR_FRONT_Z_INDEX = 60;
export const EARS_Z_INDEX = 70;
export const FACIAL_HAIR_Z_INDEX = 80;
export const ACCESSORY_Z_INDEX = 90;
export const LOGO_Z_INDEX = 100;
export const ACHIEVEMENTS_Z_INDEX = 110;
